import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { SettingsService } from '@app/core/settings/settings.service';
import { IS1InputSelectItem } from '@app/s1';
import { ISearchRuoloParams, RolesService } from '@app/shared/services/roles.service';

@Component({
    selector: 'mdm-input-user-role-select',
    templateUrl: './input-user-role-select.component.html',
    styleUrls: ['./input-user-role-select.component.scss'],
    standalone: false
})
export class InputUserRoleSelectComponent implements OnInit {

  @Input() control: UntypedFormControl;

  rolesList: IS1InputSelectItem[];

  constructor(private rolesService: RolesService) { 
    this.loadRoles();
  }

  ngOnInit(): void {
  }

  loadRoles() {

    this.rolesList = [];

    const params: ISearchRuoloParams = {
      paging: false
    }

    this.rolesService.getRuoli(params).subscribe(ruoliPaginati => {

      this.rolesList = ruoliPaginati.ruoli.map(ruolo => {

        return {
          code: ruolo.code,
          label: ruolo.description
        } as IS1InputSelectItem

      })

    }) 

  }

}
